<template>
  <div>
    <h1>Informe de Estatus de Querellas nivel Central</h1>
  </div>
</template>

<script>
export default {
  name: 'CentralLevelComplaintsStatusMain',
}
</script>

<style lang="scss" scoped></style>
